export const readNextLessonValue = (nextLessonInfo: unknown, snakeKey: string, camelKey: string) => {
  const info = nextLessonInfo as Record<string, unknown> | null | undefined
  return info?.[snakeKey] ?? info?.[camelKey]
}

export const toFiniteNumber = (value: unknown, fallback: number) => {
  if (value === null || value === undefined || value === '') {
    return fallback
  }

  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : fallback
}

export const readNextLessonNumber = (nextLessonInfo: unknown, snakeKey: string, camelKey: string, fallback: number) => {
  return toFiniteNumber(readNextLessonValue(nextLessonInfo, snakeKey, camelKey), fallback)
}

export const readNextLessonOptionalNumber = (nextLessonInfo: unknown, snakeKey: string, camelKey: string) => {
  const numberValue = toFiniteNumber(readNextLessonValue(nextLessonInfo, snakeKey, camelKey), Number.NaN)
  return Number.isFinite(numberValue) ? numberValue : null
}

export const readNextLessonString = (nextLessonInfo: unknown, snakeKey: string, camelKey: string) => {
  const value = readNextLessonValue(nextLessonInfo, snakeKey, camelKey)
  return typeof value === 'string' ? value : value === null || value === undefined ? undefined : String(value)
}
